import { render, staticRenderFns } from "./QuestionsForm.vue?vue&type=template&id=4af4be89&scoped=true&"
import script from "./QuestionsForm.vue?vue&type=script&lang=js&"
export * from "./QuestionsForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsForm.vue?vue&type=style&index=0&id=4af4be89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4be89",
  null
  
)

export default component.exports